<template>
  <div>
    <Modal max-width="540" :show.sync="showAnonModal" :close="closeAnonModal">
      <template #title>
        <h3 class="bold">Anonymiser le client </h3>
      </template>
      <template #text>
        <h2 class="bold">
          Ce processus est irréversible, êtes-vous sûr de vouloir le faire ?
        </h2>
      </template>
      <v-spacer />
      <template #actions>
        <v-col class="d-flex col-12">
          <v-btn class="col-6 mr-1 mb-2" color="secondary" @click="closeAnonModal()">
            <span class="d-none d-sm-inline-block">Non, garder-le</span>
          </v-btn>
          <v-btn class="col-6 ml-1" color="primary" @click="anonymiseCustomer()">
            <span class="d-none d-sm-inline-block">Oui, anonymiser</span>
          </v-btn>
        </v-col>
      </template>
    </Modal>
  </div>
</template>
<script>
import { EventBus } from '../../mixins';
import Modal from '@/components/Modal/Modal';

import { requests } from '@/mixins/index';

export default {
  components: { Modal },
  mixins: [requests],
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  data () {
    return { showAnonModal: false };
  },
  mounted () {
    EventBus.$on('show-anon-modal', () => {
      this.showAnonModal = true;
    });
  },
  methods: {
    closeAnonModal () {
      this.showAnonModal = false;
    },
    async anonymiseCustomer () {
      this.closeAnonModal();
      const notification = {
        message: "Commencer l'anonymisation du client",
        type: 'info',
        timeout: 16000
      };
      EventBus.$emit('show-notifications', [notification]);

      await this.anonymiseCustomerFederationRequest(this.$props.uuid);
      EventBus.$emit('user-updated');
    }
  }
};
</script>
